<template>
    <div class="skeleton" :style="{width, height}"></div>
</template>

<script setup lang="ts">
    defineProps({
        height: {type: String, default: '44px'},
        width: {type: String, default: '100%'},
    });
</script>

<style lang="scss" scoped>
    .skeleton {
        overflow: hidden;
        position: relative;
        background-color: var(--joy-color-secondary-10);
        width: 100%;
        height: 44px;
        border-radius: var(--joy-core-radius-3);

        &::after {
            content: '';
            transform: translateX(100%);
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
            animation: slide 0.8s infinite linear;
            background-image: linear-gradient(
                to right,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.8) 50%,
                rgba(128, 186, 232, 0) 99%,
                rgba(125, 185, 232, 0) 100%
            );
        }
    }

    @keyframes slide {
        0% {
            transform: translateX(-100%);
        }
        100% {
            transform: translateX(100%);
        }
    }
</style>
